export default {
  ID: 'wix-vod-payment',
  TYPES: {
    SALE: 'sale',
    RENT: 'rent',
    SUBSCRIPTION: 'subscription',
    SUBSCRIPTION_CANCEL: 'subscription-cancel',
  },
};



// WEBPACK FOOTER //
// ./src/widget/constants/payment-message-proxy.js